import { render } from "./FooterComp.vue?vue&type=template&id=59cf7759&ts=true"
import script from "./FooterComp.vue?vue&type=script&lang=ts"
export * from "./FooterComp.vue?vue&type=script&lang=ts"

import "./FooterComp.vue?vue&type=style&index=0&id=59cf7759&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__